(function menoplayCartPageModule(window, document) {
  "use strict";

  var selectors = {
    root: "[data-menoplay-cart-page]",
    item: "[data-menoplay-page-item]",
    quantity: "[data-menoplay-page-quantity]",
    modalityToggle: "[data-menoplay-page-modality-toggle]",
    modalityOpen: "[data-menoplay-page-modality-open]",
    upgrade: "[data-menoplay-page-upgrade]",
    subscriptionSwitch: "[data-menoplay-page-subscription-switch]",
    remove: "[data-menoplay-page-remove]",
    cedula: "[data-menoplay-page-cedula]",
    cedulaError: "[data-menoplay-page-cedula-error]",
    terms: "[data-menoplay-page-terms]",
    checkout: "[data-menoplay-page-checkout]",
    checkoutLabel: "[data-menoplay-page-checkout-label]",
    status: "[data-menoplay-page-status]",
    error: "[data-menoplay-page-error]",
    nextCharge: "[data-menoplay-page-next-charge]",
    resolveMixed: "[data-menoplay-page-resolve-mixed]",
  };

  function cartUrl(path) {
    return ((window.theme && window.theme.routes && window.theme.routes.cart) || "/cart") + path;
  }

  function nextChargeDate() {
    var today = new Date();
    var month = today.getMonth() + 1;
    var lastDay = new Date(today.getFullYear(), month + 1, 0).getDate();
    return new Intl.DateTimeFormat("es-CO", { day: "numeric", month: "long", year: "numeric" }).format(new Date(today.getFullYear(), month, Math.min(today.getDate(), lastDay)));
  }

  function CartPage(root) {
    this.root = root;
    this.cedula = "";
    this.cedulaSaved = false;
    this.cedulaSaveTimer = null;
    this.isSavingCedula = false;
    this.cedulaSavePromise = null;
    this.isCheckoutPreparing = false;
    this.termsAccepted = false;
    this.isUpdating = false;
    this.isMixed = root.getAttribute("data-menoplay-page-mixed") === "true";
    this.bind();
    this.refreshDynamicCopy();
  }

  CartPage.prototype.find = function (selector) { return this.root.querySelector(selector); };
  CartPage.prototype.announce = function (message) { var status = this.find(selectors.status); if (status) status.textContent = message; };
  CartPage.prototype.showError = function (message) { var error = this.find(selectors.error); if (error) { error.textContent = message; error.hidden = false; } this.announce(message); };
  CartPage.prototype.clearError = function () { var error = this.find(selectors.error); if (error) { error.textContent = ""; error.hidden = true; } };
  CartPage.prototype.isSubscription = function () { return Boolean(this.find(selectors.terms)); };
  CartPage.prototype.requiresCedula = function () { return this.root.getAttribute("data-country-code") === "CO" && Boolean(this.find(selectors.cedula)); };
  CartPage.prototype.updateCheckoutState = function () {
    var checkout = this.find(selectors.checkout);
    if (checkout) checkout.disabled = this.isMixed || (this.isSubscription() && !this.termsAccepted) || this.isUpdating || this.isSavingCedula || this.isCheckoutPreparing;
  };
  CartPage.prototype.clearCedulaError = function () {
    var input = this.find(selectors.cedula); var error = this.find(selectors.cedulaError);
    if (input) { input.removeAttribute("aria-invalid"); input.classList.remove("menoplay-cart-page__cedula--shake"); }
    if (error) error.textContent = "";
  };
  CartPage.prototype.resetTermsAcceptance = function () {
    var terms = this.find(selectors.terms);
    this.termsAccepted = false;
    if (terms) terms.checked = false;
  };
  CartPage.prototype.showCedulaError = function (message) {
    var input = this.find(selectors.cedula); var error = this.find(selectors.cedulaError);
    if (input) input.setAttribute("aria-invalid", "true");
    if (error) error.textContent = message;
    this.announce(message);
  };
  CartPage.prototype.focusCedulaError = function () {
    var input = this.find(selectors.cedula);
    if (!input) return;
    input.classList.remove("menoplay-cart-page__cedula--shake");
    void input.offsetWidth;
    input.classList.add("menoplay-cart-page__cedula--shake");
    input.focus();
  };
  CartPage.prototype.refreshDynamicCopy = function () {
    var next = this.find(selectors.nextCharge); var input = this.find(selectors.cedula); var terms = this.find(selectors.terms);
    if (next) next.textContent = nextChargeDate();
    if (input) input.value = this.cedula;
    if (terms) terms.checked = this.termsAccepted;
    this.updateCheckoutState();
  };
  CartPage.prototype.refresh = async function () {
    window.location.reload();
  };
  CartPage.prototype.fetchCart = async function () {
    var response = await fetch(cartUrl(".js"), { credentials: "same-origin" });
    if (!response.ok) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
    return response.json();
  };
  CartPage.prototype.findOriginalCartLine = function (cart, item) {
    var originalKey = item.getAttribute("data-cart-key");
    var variantId = item.getAttribute("data-variant-id");
    var sellingPlanId = item.getAttribute("data-selling-plan-id") || "";
    var matches = (cart.items || []).filter(function (line) {
      var allocation = line.selling_plan_allocation;
      var lineSellingPlanId = allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : "";
      return String(line.variant_id) === variantId && lineSellingPlanId === sellingPlanId;
    });
    var keyedLine = matches.find(function (line) { return String(line.key) === originalKey; });
    if (keyedLine) return keyedLine;
    return matches.length === 1 ? matches[0] : undefined;
  };
  CartPage.prototype.findSoleReplacementCartLine = function (cart, sourceKey, replacement, variantId, sellingPlanId) {
    var guard = window.MenoPlayCartLimit;
    var replacementKey = replacement && replacement.key;
    var lines = guard && guard.getLines ? guard.getLines(cart) : [];
    var requestedSellingPlanId = sellingPlanId || "";
    var sourceStillPresent = (cart.items || []).some(function (line) { return String(line.key) === String(sourceKey); });
    var matches = lines.filter(function (line) {
      var allocation = line.selling_plan_allocation;
      var lineSellingPlanId = allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : "";
      return (replacementKey && String(line.key) === String(replacementKey)) || (String(line.variant_id) === String(variantId) && lineSellingPlanId === requestedSellingPlanId);
    });
    return !sourceStillPresent && lines.length === 1 && matches.length === 1 ? matches[0] : undefined;
  };
  CartPage.prototype.rollbackReplacement = async function (replacement, addedQuantity) {
    if (!replacement || !replacement.key) throw new Error("No pudimos restaurar tu carrito. Actualiza la página antes de volver a intentarlo.");
    var replacementQuantity = Number(replacement.quantity);
    var quantity = Number.isFinite(replacementQuantity) ? Math.max(0, replacementQuantity - addedQuantity) : 0;
    var response = await fetch(cartUrl("/change.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: replacement.key, quantity: quantity }) });
    if (!response.ok) throw new Error("No pudimos restaurar tu carrito. Actualiza la página antes de volver a intentarlo.");
  };
  CartPage.prototype.updateQuantity = async function (item, quantity, sellingPlanId) {
    var key = item && item.getAttribute("data-cart-key");
    var variantId = item && item.getAttribute("data-variant-id");
    var replacement; var originalLine; var replacementAdded = false; var replacementComplete = false; var replacementQuantity = sellingPlanId ? 1 : quantity; var response; var sendReplacementAdd;
    var currentSellingPlanId = item && item.getAttribute("data-selling-plan-id");
    var isOneTimeQuantityChange = quantity > 0 && !sellingPlanId && !currentSellingPlanId;
    if (!key || this.isUpdating) return;
    this.isUpdating = true; this.root.classList.add("is-updating"); this.clearError(); this.updateCheckoutState();
    this.announce(quantity === 0 ? "Eliminando producto..." : "Actualizando tu modalidad...");
    try {
      if (quantity > 0 && window.MenoPlayCartLimit) {
        if (window.MenoPlayCartLimit.registerVariantIds && variantId) {
          window.MenoPlayCartLimit.registerVariantIds(variantId);
        }
        if (isOneTimeQuantityChange) {
          if (!window.MenoPlayCartLimit.replaceOneTimePackageQuantity) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
          await window.MenoPlayCartLimit.replaceOneTimePackageQuantity(key, variantId, quantity);
          replacementComplete = true;
        } else {
          sendReplacementAdd = await window.MenoPlayCartLimit.beginReplacement(key, variantId);
        }
      }
      if (quantity === 0) {
        response = await fetch(cartUrl("/change.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) });
        if (!response.ok) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
      } else if (!isOneTimeQuantityChange) {
        if (!variantId) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
        var preAddCart = await this.fetchCart();
        originalLine = this.findOriginalCartLine(preAddCart, item);
        if (!originalLine || !originalLine.key) throw new Error("No pudimos identificar la selección original. Intenta nuevamente.");
        var body = new URLSearchParams();
        body.set("id", variantId); body.set("quantity", String(sellingPlanId ? 1 : quantity));
        if (sellingPlanId) body.set("selling_plan", sellingPlanId);
        response = await (sendReplacementAdd || fetch)(cartUrl("/add.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: body.toString() });
        if (!response.ok) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
        replacement = await response.json(); replacementAdded = true;
        if (replacement && replacement.key === key) {
          response = await fetch(cartUrl("/change.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: replacement.key, quantity: replacementQuantity }) });
          if (!response.ok) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
          replacementComplete = true;
        } else {
          var cart = await this.fetchCart();
          var sourceStillPresent = (cart.items || []).some(function (line) { return String(line.key) === String(originalLine.key); });
          if (!sourceStillPresent) {
            var replacementLine = this.findSoleReplacementCartLine(cart, originalLine.key, replacement, variantId, sellingPlanId);
            if (!replacementLine) throw new Error("No pudimos identificar la selección original. Intenta nuevamente.");
            replacementComplete = true;
          } else {
            response = await fetch(cartUrl("/change.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: originalLine.key, quantity: 0 }) });
            if (!response.ok) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente.");
            replacementComplete = true;
          }
        }
      }
      document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true }));
      await this.refresh();
    } catch (error) {
      if (replacementAdded && !replacementComplete) {
        try { await this.rollbackReplacement(replacement, replacementQuantity); }
        catch (rollbackError) { error = rollbackError; }
      }
      this.showError(error.message || "No pudimos actualizar tu carrito. Intenta nuevamente.");
    } finally { this.isUpdating = false; this.root.classList.remove("is-updating"); this.updateCheckoutState(); }
  };
  CartPage.prototype.getFiscalProductContext = function () {
    var item = this.find(selectors.item);
    var selectedQuantity = this.find(selectors.quantity + ":checked");
    return {
      variant_id: item && item.getAttribute("data-variant-id"),
      product_id: item && item.getAttribute("data-product-id"),
      line_item_key: item && item.getAttribute("data-cart-key"),
      pack_quantity: (selectedQuantity && selectedQuantity.value) || (item && item.getAttribute("data-subscription") === "true" ? 1 : null),
    };
  };
  CartPage.prototype.clearCedulaSaveTimer = function () {
    if (this.cedulaSaveTimer) window.clearTimeout(this.cedulaSaveTimer);
    this.cedulaSaveTimer = null;
  };
  CartPage.prototype.scheduleCedulaSave = function () {
    var fiscal = window.EusariFiscalColombia; var self = this; var documentValue;
    if (this.isSavingCedula) return;
    this.clearCedulaSaveTimer();
    if (!fiscal || !fiscal.normalizeDocument || !fiscal.validateFiscalDocument) return;
    documentValue = fiscal.normalizeDocument(this.cedula);
    if (!fiscal.validateFiscalDocument(documentValue)) return;
    this.cedulaSaveTimer = window.setTimeout(function saveValidCedula() {
      self.cedulaSaveTimer = null;
      if (self.cedula !== documentValue || self.cedulaSaved) return;
      self.saveCedula().then(function () { self.updateCheckoutState(); }).catch(function () { self.updateCheckoutState(); });
    }, 600);
  };
  CartPage.prototype.saveCedulaTask = async function () {
    var fiscal = window.EusariFiscalColombia; var input = this.find(selectors.cedula); var documentValue; var record; var productContext; var payload; var item;
    var checkoutLabel = this.find(selectors.checkoutLabel); var wasLoading = this.root.classList.contains("is-loading");
    if (!fiscal || !fiscal.normalizeDocument || !fiscal.validateFiscalDocument || !fiscal.createFiscalRecord || !fiscal.syncCartNote || !fiscal.buildWebhookPayload || !fiscal.sendFiscalWebhook) throw new Error("No pudimos preparar la información fiscal. Intenta nuevamente.");
    this.clearCedulaSaveTimer();
    documentValue = fiscal.normalizeDocument(this.cedula);
    this.cedula = documentValue;
    if (input) input.value = documentValue;
    if (!fiscal.validateFiscalDocument(documentValue)) { this.showCedulaError("Ingresa un NIT o Cédula válido para Colombia."); throw new Error("Cédula inválida."); }
    this.isSavingCedula = true;
    this.root.classList.add("is-loading");
    this.updateCheckoutState();
    if (checkoutLabel) checkoutLabel.textContent = "Validando...";
    this.announce("Validando...");
    try {
      record = fiscal.createFiscalRecord(documentValue);
      productContext = this.getFiscalProductContext();
      await fiscal.syncCartNote(record, productContext);
      item = this.find(selectors.item);
      if (item && productContext.line_item_key) item.setAttribute("data-cart-key", productContext.line_item_key);
      payload = fiscal.buildWebhookPayload(record, productContext);
      fiscal.sendFiscalWebhook(payload).catch(function (error) { console.error("[MenoPlayCartPage] Fiscal webhook failed without blocking checkout preparation.", error); });
      this.cedulaSaved = this.cedula === documentValue;
      if (this.cedulaSaved) this.clearCedulaError();
    } finally {
      this.isSavingCedula = false;
      if (this.cedula !== documentValue && !this.isCheckoutPreparing) this.scheduleCedulaSave();
      this.updateCheckoutState();
      if (!wasLoading) {
        this.root.classList.remove("is-loading");
        if (checkoutLabel) checkoutLabel.textContent = "Ir al pago";
      }
    }
  };
  CartPage.prototype.saveCedula = function () {
    var self = this;
    if (this.cedulaSavePromise) return this.cedulaSavePromise;
    this.cedulaSavePromise = this.saveCedulaTask().finally(function () {
      self.cedulaSavePromise = null;
    });
    return this.cedulaSavePromise;
  };
  CartPage.prototype.resolveMixed = async function (keepSubscription) {
    var items = Array.prototype.slice.call(this.root.querySelectorAll(selectors.item));
    var removals = items.filter(function (item) { return (item.getAttribute("data-subscription") === "true") !== keepSubscription; });
    if (!removals.length || this.isUpdating) return;
    this.isUpdating = true; this.root.classList.add("is-updating"); this.updateCheckoutState();
    this.announce("Actualizando tu modalidad...");
    try {
      await Promise.all(removals.map(function (item) {
        return fetch(cartUrl("/change.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: item.getAttribute("data-cart-key"), quantity: 0 }) }).then(function (response) { if (!response.ok) throw new Error("No pudimos actualizar tu carrito. Intenta nuevamente."); });
      }));
      document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true }));
      await this.refresh();
    } catch (error) { this.showError(error.message || "No pudimos actualizar tu carrito. Intenta nuevamente."); }
    finally { this.isUpdating = false; this.root.classList.remove("is-updating"); this.updateCheckoutState(); }
  };
  CartPage.prototype.checkout = async function () {
    var checkout = this.find(selectors.checkout); var label = this.find(selectors.checkoutLabel);
    var input; var fiscal; var documentValue;
    if (!checkout || this.isUpdating || this.isCheckoutPreparing || this.isMixed) return;
    if (this.isSubscription() && !this.termsAccepted) { this.showError("Acepta los términos de la suscripción para continuar."); return; }
    if (this.requiresCedula()) {
      input = this.find(selectors.cedula);
      fiscal = window.EusariFiscalColombia;
      documentValue = fiscal && fiscal.normalizeDocument ? fiscal.normalizeDocument(input ? input.value : this.cedula) : this.cedula;
      if (this.cedula !== documentValue) this.cedulaSaved = false;
      this.cedula = documentValue;
      if (input) input.value = documentValue;
      if (!fiscal || !fiscal.validateFiscalDocument || !fiscal.validateFiscalDocument(documentValue)) {
        this.showCedulaError("Ingresa un NIT o Cédula válido para Colombia.");
        this.focusCedulaError();
        return;
      }
    }
    this.isCheckoutPreparing = true;
    this.isUpdating = true;
    this.root.classList.add("is-loading");
    if (label) label.textContent = "Preparando tu pago…";
    this.updateCheckoutState();
    try {
      if (this.requiresCedula() && !this.cedulaSaved) await this.saveCedula();
      if (this.requiresCedula()) {
        input = this.find(selectors.cedula);
        documentValue = fiscal.normalizeDocument(input ? input.value : this.cedula);
        if (!fiscal.validateFiscalDocument(documentValue) || !this.cedulaSaved || this.cedula !== documentValue) {
          this.showCedulaError("El número cambió mientras lo validábamos. Revísalo e intenta nuevamente.");
          this.focusCedulaError();
          return;
        }
      }
      window.location.assign(((window.theme && window.theme.routes && window.theme.routes.root_url) || "/").replace(/\/?$/, "/") + "checkout");
    } catch (error) {
      if (error.message !== "Cédula inválida.") this.showError(error.message || "No pudimos preparar el pago. Intenta nuevamente.");
    } finally {
      this.isCheckoutPreparing = false;
      this.isUpdating = false;
      this.root.classList.remove("is-loading");
      if (label) label.textContent = "Ir al pago";
      this.updateCheckoutState();
    }
  };
  CartPage.prototype.bind = function () {
    var self = this;
    this.root.addEventListener("input", function (event) {
      var fiscal; var documentValue; var digitCount;
      if (!event.target.matches(selectors.cedula)) return;
      fiscal = window.EusariFiscalColombia;
      documentValue = fiscal && fiscal.normalizeDocument ? fiscal.normalizeDocument(event.target.value) : event.target.value;
      self.cedula = documentValue;
      event.target.value = documentValue;
      self.cedulaSaved = false;
      self.resetTermsAcceptance();
      self.clearCedulaError();
      digitCount = documentValue.replace(/\D/g, "").length;
      if (fiscal && fiscal.validateFiscalDocument && digitCount >= 7 && !fiscal.validateFiscalDocument(documentValue)) self.showCedulaError("Ingresa un NIT o Cédula válido para Colombia.");
      self.updateCheckoutState();
      self.scheduleCedulaSave();
    });
    this.root.addEventListener("focusout", function (event) {
      var fiscal = window.EusariFiscalColombia;
      var checkoutTarget = event.relatedTarget && event.relatedTarget.closest && event.relatedTarget.closest(selectors.checkout);
      if (checkoutTarget || !event.target.matches(selectors.cedula) || !fiscal || !fiscal.validateFiscalDocument || !fiscal.validateFiscalDocument(self.cedula)) return;
      self.clearCedulaSaveTimer();
      if (!self.cedulaSaved) self.saveCedula().then(function () { self.updateCheckoutState(); }).catch(function () { self.updateCheckoutState(); });
    });
    this.root.addEventListener("change", function (event) { if (event.target.matches(selectors.quantity)) self.updateQuantity(event.target.closest(selectors.item), Number(event.target.value)); if (event.target.matches(selectors.terms)) { self.termsAccepted = event.target.checked; self.updateCheckoutState(); } });
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      self.cedula = "";
      self.cedulaSaved = false;
      self.clearCedulaSaveTimer();
      self.resetTermsAcceptance();
      var input = self.find(selectors.cedula);
      if (input) input.value = "";
      self.clearCedulaError();
      self.updateCheckoutState();
    });
    this.root.addEventListener("click", function (event) {
      var trigger = event.target.closest(selectors.modalityOpen); var action = event.target.closest(selectors.upgrade + ", " + selectors.subscriptionSwitch + ", " + selectors.resolveMixed + ", " + selectors.remove + ", " + selectors.checkout);
      if (trigger) { event.preventDefault(); var toggle = trigger.closest(selectors.item).querySelector(selectors.modalityToggle); toggle.open = !toggle.open; trigger.setAttribute("aria-expanded", String(toggle.open)); return; }
      if (!action) return; event.preventDefault(); var item = action.closest(selectors.item) || self.find(selectors.item);
      if (action.matches(selectors.upgrade)) self.updateQuantity(item, 3);
      else if (action.matches(selectors.subscriptionSwitch)) self.updateQuantity(item, 1, action.getAttribute("data-selling-plan-id"));
      else if (action.matches(selectors.resolveMixed)) self.resolveMixed(action.getAttribute("data-menoplay-page-resolve-mixed") === "subscription");
      else if (action.matches(selectors.remove)) self.updateQuantity(item, 0);
      else self.checkout();
    });
  };
  function init() { document.querySelectorAll(selectors.root).forEach(function (root) { if (!root.dataset.menoplayCartPageBound) { root.dataset.menoplayCartPageBound = "true"; new CartPage(root); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})(window, document);
